import { render, staticRenderFns } from "./ChatDateSeparator.vue?vue&type=template&id=c7df375a&scoped=true"
import script from "./ChatDateSeparator.vue?vue&type=script&lang=js"
export * from "./ChatDateSeparator.vue?vue&type=script&lang=js"
import style0 from "./ChatDateSeparator.vue?vue&type=style&index=0&id=c7df375a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7df375a",
  null
  
)

export default component.exports